import type { IconSvgObject } from './types';

const FolderClockIcon: IconSvgObject = [
  ["circle", { cx: "17", cy: "16.5", r: "5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 14.5V16.5L18.5 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 6.49446H12.0179M12.0179 6.49446H20C21.1046 6.49446 22 7.38989 22 8.49446V9.5M12.0179 6.49446L9.60016 3.29437C9.22218 2.79407 8.63144 2.5 8.0044 2.5H4C2.89543 2.5 2 3.39543 2 4.5V18.5C2 19.6046 2.89543 20.5 4 20.5H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FolderClockIcon;
